import styled from 'styled-components';
import PreviewSubtitle from 'gatsby-theme-vehicles/src/components/preview/components/subtitle';

export default styled(PreviewSubtitle)`
  font-size: 1rem;
  font-weight: 600;
  line-height: ${({ theme }) => theme.baseLineHeight};
  margin-bottom: 1rem;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 3rem;
`;
